import css from 'styled-jsx/css';

export default css`
    .LinedText {
        width: 100%;
        text-align: center;
        border-bottom: 1px solid #000;
        line-height: 0.1em;
        margin: 10px 0 20px;
    }

    .LinedText span {
        padding: 0 10px;
    }

    .ErrorLogin {
    }

    .ErrorSignup {
    }
`;
